import { render, staticRenderFns } from "./moments_topic_follow_detail.vue?vue&type=template&id=62fa7b37&scoped=true"
import script from "./moments_topic_follow_detail.vue?vue&type=script&lang=js"
export * from "./moments_topic_follow_detail.vue?vue&type=script&lang=js"
import style0 from "./moments_topic_follow_detail.vue?vue&type=style&index=0&id=62fa7b37&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa7b37",
  null
  
)

export default component.exports